import React, { useState } from 'react';
import { Typography, Box, Button, Switch, FormControlLabel } from '@mui/material';
import ActivityLayout from '../ActivityLayout';

function IdentifyColors({ onBack, onCorrect, initialTimer = null, globalTimer = null, onGlobalTimeUp, score }) {
  const colors = [
    { name: 'Rouge', symbol: '🔴', buttonEmoji: '❤️' },
    { name: 'Bleu', symbol: '🔵', buttonEmoji: '💙' },
    { name: 'Vert', symbol: '🟢', buttonEmoji: '🌿' },
    { name: 'Jaune', symbol: '🟡', buttonEmoji: '🌟' },
    { name: 'Orange', symbol: '🟠', buttonEmoji: '🍊' },
    { name: 'Violet', symbol: '🟣', buttonEmoji: '🍇' },
  ];

  const [currentColor, setCurrentColor] = useState(generateColor());
  const [emoji, setEmoji] = useState(null);
  const [showNext, setShowNext] = useState(false);
  const [babyMode, setBabyMode] = useState(false);

  function generateColor() {
    return colors[Math.floor(Math.random() * colors.length)];
  }

  const handleAnswer = (answer) => {
    if (showNext) return;
    
    const correct = answer === currentColor.name;
    setEmoji(correct ? '🎉' : '❌');
    setShowNext(true);

    if (correct) {
      onCorrect();
    }
  };

  const handleNext = () => {
    setCurrentColor(generateColor());
    setEmoji(null);
    setShowNext(false);
  };

  const toggleBabyMode = () => {
    setBabyMode(!babyMode);
  };

  const handleContainerClick = (event) => {
    if ((event.target === event.currentTarget || event.target.parentElement === event.currentTarget) && showNext) {
      handleNext();
    }
  };

  return (
    <ActivityLayout 
      onBack={onBack}
      timeLimit={initialTimer}
      globalTimeLimit={globalTimer}
      onTimeUp={() => {
        setEmoji('⏰');
        setShowNext(true);
      }}
      onGlobalTimeUp={onGlobalTimeUp}
      isPaused={showNext}
      score={score}
    >
      <Box
        onClick={handleContainerClick}
        sx={{
          cursor: showNext ? 'pointer' : 'default',
          userSelect: 'none',
          width: '100%',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 2,
          position: 'relative'
        }}
      >
        <Box sx={{ 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: 600,
          width: '100%'
        }}>
          <Typography variant="h5" align="center">
            Quelle est cette couleur ?
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
            <Typography variant="h1">{currentColor.symbol}</Typography>
          </Box>

          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: 2, 
            flexWrap: 'wrap',
            width: '100%'
          }}>
            {colors.map((color) => (
              <Button
                key={color.name}
                onClick={() => handleAnswer(color.name)}
                variant="outlined"
                sx={{ 
                  width: 100, 
                  height: 30,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.6rem',
                  gap: 1
                }}
                disabled={showNext}
              >
                {color.name} {babyMode && color.buttonEmoji}
              </Button>
            ))}
          </Box>

          {emoji && (
            <Typography variant="h1" sx={{ mt: 3 }}>
              {emoji}
            </Typography>
          )}

          {showNext && (
            <Typography align="center" sx={{ mt: 2 }}>
              Cliquez n'importe où pour continuer
            </Typography>
          )}

          <Box mt={3}>
            <FormControlLabel
              control={<Switch checked={babyMode} onChange={toggleBabyMode} />}
              label="Mode Bébé"
            />
          </Box>
        </Box>
      </Box>
    </ActivityLayout>
  );
}

export default IdentifyColors;
